export default "__VITE_PUBLIC_ASSET__68c92b1a__"